import { CommonStatus } from './../../globals/globals';
import { Component, OnInit, TemplateRef } from '@angular/core';
import { AbstractControl, UntypedFormBuilder,UntypedFormGroup, Validators } from '@angular/forms';
import { UserModelService } from '../../model/user-model/user-model.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { LocalizationService, TranslationParams } from 'src/app/util/service/internationalization/localization.service';

// import custom validator to validate that password and confirm password fields match
import { MustMatch } from '../../util/directive/mustMatch/must-match.validator';
import { AuthService } from 'src/app/model/auth-model/auth.service';
import { SystemConstantsType, UserType } from 'src/app/globals/custom-types/global-custom-types';
import { UserRole } from 'src/app/globals/globals';
import SystemConstants from 'src/app/util/constants/SystemConstants';
import { IParametersFromVerifiedLink } from 'src/app/model/user-model/user-types';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { CommonValidationService, CustomValidatorOptions } from 'src/app/util/service/common-validation.service';
import { Translations } from 'src/app/util/service/internationalization/translations.service';
@Component({
    selector: 'app-login',
    templateUrl: '../../view/login/login.component.html',
    styleUrls: ['../../view/login/login.component.scss'],
    providers: [UserModelService],
    standalone: false
})
export class LoginComponent implements OnInit {
  /**
   * Define all controller property here
   */
  loginForm: UntypedFormGroup;
  ForgotPassword: UntypedFormGroup;
  ResetPassword: UntypedFormGroup;
  sAttributeData: any = {};
  submitted = false;
  userRole: UserType;
  systemConstants: SystemConstantsType;
  bsModalRef: BsModalRef;
  isLogin:boolean;
  showVerificationMessage: boolean = false;
  isVerifyingEmail: boolean = false;
  constructor(
    private formBuilder: UntypedFormBuilder,
    private userModelService: UserModelService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private bsModalService: BsModalService,
    private toastr: ToastrService,
    private authService: AuthService,
    public translations:Translations,
    private commonValidationService: CommonValidationService,
    private localizationService: LocalizationService,
  ) {
    this.initializeProperties();
   }

  /**
   * This function will call when controller will initialze.
   */

  get username(): AbstractControl { return this.loginForm.controls.username; }

  get password(): AbstractControl { return this.loginForm.controls.password; }


  get email(): AbstractControl { return this.ForgotPassword.controls.email; }

  get resetPassword(): AbstractControl { return this.ResetPassword.controls.password; }

  get otp(): AbstractControl { return this.ResetPassword.controls.otp; }

  get confirmPassword(): AbstractControl { return this.ResetPassword.controls.confirmPassword; }
  
  ngOnInit() {
    this.getResponseDuringEmailVerification();
    this.loginFormControls();
    this.checkAuthLogin();
  }

  initializeProperties() {
    this.userRole = UserRole;
    this.systemConstants = SystemConstants;
  }

  checkAuthLogin() {
    this.authService.isLoggedIn.subscribe((isLogin: boolean) => {
      this.isLogin = isLogin;
      if (isLogin) {
        if ((localStorage.getItem(this.systemConstants.USER_ROLE_TEXT)) === UserRole.SUPER_ADMIN.toString()){
          this.router.navigate(['/dashboard']);
        }
        else if((localStorage.getItem(this.systemConstants.USER_ROLE_TEXT)) === UserRole.MERCHANT.toString()){
          this.router.navigate(['/merchant-dashboard']);
        }
         }
    }, err => {
      this.router.navigateByUrl('/');
    });
  }

  getResponseDuringEmailVerification() {
    this.activatedRoute.queryParams.subscribe((parametersFromLink: IParametersFromVerifiedLink) => {
      if (Object.entries(parametersFromLink).length != 0) {
        this.isVerifyingEmail = true;
        this.userModelService.getEmailVerification(parametersFromLink).subscribe((res: any) => {
          if(res && res.status === this.systemConstants.OKAY_MSG){
            this.toastr.success(this.systemConstants.SUCCESS, res.data);
          }
          if (res && res.status ) {
            if (res.status === this.systemConstants.CAPITAL_ERROR_MSG) {
              this.showVerificationMessage = true;
              this.toastr.error(this.systemConstants.LINK_EXPIRED_VERIFICATION_MSG);
              this.router.navigate(['/']);
            } else {
              if(localStorage.getItem(SystemConstants.AUTH_TOKEN) && localStorage.getItem(SystemConstants.USER_ROLE_TEXT) === UserRole.SUPER_ADMIN.toString() ){
                this.toastr.success(this.systemConstants.SUCCESS, res.data);
                this.router.navigate(['/admin-user']);
              } else {
                this.router.navigate(['/']);
              }
            }
          }else {
            this.router.navigate(['/login'])
          }
        }, (error) => {
          this.isVerifyingEmail = false;
          console.log(error);
        })
      }
    })
  }
  /***
   * login forms controls function
   */
  loginFormControls(){
    this.loginForm = this.formBuilder.group({
      username: ['', [Validators.required, Validators.email]],
      // password: ['',this.commonValidationService.setCustomValidatorMethods({minLength:6})
      password: ['', Validators.required]
    });

    this.ForgotPassword = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
    });

    this.ResetPassword = this.formBuilder.group({
      otp: ['', [Validators.required, Validators.pattern(/^-?(0|[1-9]\d*)?$/)]],
      // password: ['', this.commonValidationService.setCustomValidatorMethods({minLength:6})],
  password: [
    '',
    [
      Validators.required,
      this.commonValidationService.strongPassword()
    ]
  ],      confirmPassword: ['', Validators.required]
    }, {
      validator: MustMatch('password', 'confirmPassword')
  });
  }

  /**
   * This function will use to get user data during form submit.
   * Form data should be valid before request to API
   */

  onSubmit(template?: TemplateRef<any>) {
    if (this.loginForm.invalid) {
      this.submitted = true;
      return;
    }
    this.showVerificationMessage = false;
    this.userModelService.getLoginUser(this.loginForm.value).subscribe(res => {
       if (res && res.data) {
         if (res.data.status === this.systemConstants.OKAY_MSG) {
          this.authService.isLoggedInForHeaderSubject.next(false);
          localStorage.setItem("isLoggedInSuccessfully", JSON.stringify(true));
          if (res.decodeData && res.decodeData.data && res.decodeData.data.role === this.userRole.SUPER_ADMIN) {
            localStorage.setItem('backUrl', '/dashboard');
            localStorage.setItem('role', res.decodeData.data.role)
            this.toastr.clear();
            this.router.navigateByUrl('/dashboard');
            this.toastr.success(this.systemConstants.SUCCESS, this.systemConstants.LOGIN_MSG);
          }
          if( res.decodeData && res.decodeData.data && res.decodeData.data.role === this.userRole.MERCHANT) {
            localStorage.setItem('backUrl', '/merchant-dashboard');
            localStorage.setItem('role', res.decodeData.data.role)
            this.toastr.clear();
            this.router.navigateByUrl('/merchant-dashboard');
            this.toastr.success(this.systemConstants.SUCCESS, this.systemConstants.LOGIN_MSG);
          }
          if( res.decodeData && res.decodeData.data && res.decodeData.data.role === this.userRole.LOCALE_ADMIN) {
            localStorage.setItem('backUrl', '/locale-admin');
            localStorage.setItem('role', res.decodeData.data.role)
            this.toastr.clear();
            this.router.navigateByUrl('/locale-admin');
            this.toastr.success(this.systemConstants.SUCCESS, this.systemConstants.LOGIN_MSG);
          }
          if(res.decodeData && res.decodeData.data && res.decodeData.data.role === UserRole.USER){
            localStorage.setItem('backUrl', '/user');
            localStorage.setItem('role', res.decodeData.data.role)
            this.toastr.clear();
            this.router.navigateByUrl('/user/user-programs');
            this.toastr.success(this.systemConstants.SUCCESS, this.systemConstants.LOGIN_MSG);
          }
         } else {
          this.toastr.clear();
          if (res.data.errMsg && res.data.errMsg.includes(this.systemConstants.VERIFY_ACCOUNT)) {
            this.showVerificationMessage = true;
            this.toastr.error(this.systemConstants.ERROR, this.systemConstants.ACCOUNT_NOT_VERIFIED_MSG);
          } else {
            this.toastr.error(this.systemConstants.ERROR, res.data.errMsg);
          }         
          if (res.data.errMsg === this.systemConstants.LOGIN_EXPIRED_ERROR) {
            this.toastr.clear();
            this.toastr.error(this.systemConstants.ERROR, res.data.message);
            const config = {
              backdrop: true,
              ignoreBackdropClick: true,
              class: 'generateVerificationLinkModal'
            };
            this.bsModalRef = this.bsModalService.show(template, config);
          }
         }
      }
    }, err => {
      if (err && err.error && err.error.error && err.error.error.message) {
        this.toastr.error(this.systemConstants.ERROR, err.error.error.message);
      }
    });
  }

  forgotPassword() {
    if (this.ForgotPassword.invalid) {
      this.submitted = true;
      return;
    }
    this.sAttributeData.fpEmail = this.ForgotPassword.value.email
    this.userModelService.forgotPassword(this.ForgotPassword.value).subscribe(res => {
      if(res && res.status === 'OKAY'){
        this.toastr.success('success', res.data);
        this.sAttributeData.isFP = false;
        this.sAttributeData.isOTP = true;
        this.ForgotPassword.reset()
      }
      if(res && res.status === 'ERROR'){
        this.toastr.error('error', res.errMsg);
        this.ForgotPassword.reset()
      }
    }, err => {
      if (err && err.errMsg) {
        this.toastr.error('error', err.errMsg);
      }
    });
  }

  updatePassword() {
    if (this.ResetPassword.invalid) {
      this.submitted = true;
      return;
    }
    //console.log(this.ResetPassword.value)
    const passData = this.ResetPassword.value
    passData.otp = Number(passData.otp)
    passData.email = this.sAttributeData.fpEmail
    this.userModelService.updatePassword(passData).subscribe(res => {
      if(res && res.status === 'OKAY'){
        this.toastr.success('success', res.data);
        this.sAttributeData.isFP = false;
        this.sAttributeData.isOTP = false;
        this.ResetPassword.reset()
      }
      if(res && res.status === 'ERROR'){
        this.toastr.error('error', res.errMsg);
        this.ResetPassword.reset()
      }
    }, err => {
      if (err && err.errMsg) {
        this.toastr.error('error', err.errMsg);
      }
    });
  }

  generateVerificationLink() {
    this.userModelService.generateVerificationLink(this.loginForm.value.username).subscribe((res) => {
      if (res) {
        if (res.status === this.systemConstants.CAPITAL_ERROR_MSG) {
          this.toastr.error(this.systemConstants.ERROR, res.errMsg);
        }
        if (res.status === this.systemConstants.OKAY_MSG) {
          this.toastr.success(this.systemConstants.SUCCESS, res.data);
        }
      }
      this.bsModalRef.hide();
    }, (error) => {
      console.error(error);
    });
  }

  resendVerificationEmail() {
    if (!this.loginForm.value.username) {
      this.toastr.error(this.systemConstants.ERROR, this.systemConstants.ENTER_EMAIL_ADDRESS);
      return;
    }
    this.userModelService.generateVerificationLink(this.loginForm.value.username).subscribe((res) => {
      if (res) {
        if (res.status === this.systemConstants.CAPITAL_ERROR_MSG) {
          this.toastr.error(this.systemConstants.ERROR, res.errMsg);
        }
        if (res.status === this.systemConstants.OKAY_MSG) {
          this.toastr.success(this.systemConstants.SUCCESS, this.systemConstants.VERIFICATION_EMAIL_SENT_MSG);
          this.showVerificationMessage = false;
        }
      }
    }, (error) => {
      console.error(error);
      this.toastr.error(this.systemConstants.ERROR, this.systemConstants.FAILED_TO_SEND_EMAIL);
    });
  }

  getCustomErrorMessage(formControl: AbstractControl, formControlName: string, options?: CustomValidatorOptions): string {
    return this.commonValidationService.getCustomErrorMessage(formControl, formControlName, options);
  }
  getTranslation(key: string, options?: TranslationParams): string {
    return this.localizationService.getTranslation(key, options)
  }
  resetUpdatePasswordForm() {
    this.ResetPassword.reset(); // Reset the Reset Password form
  }
}
